module.exports = __webpack_public_path__ + "static/media/section-distribution-disabled.854dd0a5.svg";